import { coinTokens } from "../domain/coinTokens";
import type { Currency, Price } from "../domain/currency";
import { currency } from "../domain/currency";

export async function fetchCoinGeckoPrices(target?: Currency) {
  const coingeckoIds: string[] = [];
  const idsToSymbolMap: Record<string, string> = {};
  Object.entries(coinTokens).forEach(([symbol, token]) => {
    if (token.coingeckoId && !!token.fetchPrice) {
      coingeckoIds.push(token.coingeckoId);
      idsToSymbolMap[token.coingeckoId] = symbol;
    }
  });

  const response = await fetch(
    `https://api.coingecko.com/api/v3/simple/price?ids=${coingeckoIds?.join(
      ","
    )}&vs_currencies=${target ?? currency.usd}`
  );

  if (!response.ok) {
    throw new Error(`${response.statusText} /// ${response.status}`);
  }

  const result = await response.json();

  if (result.status?.error_code === 429) {
    throw new Error("Rate limit exeeded!");
  }

  const prices: Record<string, Price> = {};
  Object.entries(result).forEach(([key, entry]) => {
    prices[idsToSymbolMap[key]] = entry as Price;
  });

  return prices;
}
